import { AccountCircle, Lock, VpnKey } from '@mui/icons-material';
import { Button, InputAdornment, Stack } from '@mui/material';
import type { SyntheticEvent } from 'react';
import { WhiteTextField } from '../../../styles/WhiteTextFieldStyle';

interface Step2Props {
  email: string;
  code: string;
  password: string;
  onCodeChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSubmit: (e: SyntheticEvent<HTMLFormElement>) => void;
  error: { code: boolean; password: boolean };
}

export function ResetPasswordStep2({
  email,
  code,
  password,
  onCodeChange,
  onPasswordChange,
  onSubmit,
  error,
}: Step2Props) {
  return (
    <form autoComplete="off" onSubmit={onSubmit}>
      <Stack spacing={3}>
        <h2>パスワード再設定</h2>

        <WhiteTextField
          label="Email"
          id="email"
          name="email"
          fullWidth
          size="small"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            },
          }}
          value={email}
          disabled
        />

        <WhiteTextField
          label="Code"
          id="code"
          name="code"
          fullWidth
          size="small"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <VpnKey />
                </InputAdornment>
              ),
            },
          }}
          value={code}
          onChange={(e) => onCodeChange(e.target.value)}
          error={error.code}
          helperText={error.code ? 'コードを入力してください' : ''}
        />

        <WhiteTextField
          label="New Password"
          id="password"
          name="password"
          type="password"
          fullWidth
          size="small"
          placeholder="大文字・小文字・記号を１文字以上含む"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Lock />
                </InputAdornment>
              ),
            },
          }}
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          error={error.password}
          helperText={error.password ? 'パスワードを入力してください' : ''}
        />

        <Button type="submit">確定</Button>
      </Stack>
    </form>
  );
}
